// extracted by mini-css-extract-plugin
export default {"container":"AmbientHints_container__YEwio"};